export default __webpack_public_path__ + "static/media/guna_homes_buyers_2.9a4f2249.png";